module.exports = __webpack_public_path__ + "img/showcase-searches-en-us.d4ccbb28.jpg";